<div class="sticky_header">
    <div class="header">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <a routerLink="/">
                        <img src="assets/images/logo.svg" alt="" />
                    </a>
                </div>
                <div class="col-md-6 text-end d-none d-md-block">
                    <p><a href="#">Contact Sales</a></p>
                </div>
            </div>
        </div>    
    </div>
    <div class="app_progress-bar d-md-none">
        <div class="app_progress-bar-covered" [ngClass]="{'contact': hasRoute('contact'), 'organisation': hasRoute('organisation'), 'services': hasRoute('services'), 'clinic-details': hasRoute('clinic-details'), 'billing': hasRoute('billing'), 'review-details': hasRoute('review-details')}"></div>
    </div>
</div>